import React, { useState } from "react";
import Modal from "react-modal";
import ResolutionForm from "./ResolutionForm";
import DetailModHeader from "../common-components/DetailModHeader";
import TrialAssignForm from "../pt/three-day-trial/TrialAssignForm";
import ThreedayTrialHistory from "../pt/three-day-trial/ThreedayTrialHistory";
import TrainerMemberMap from "../trainer-member-engagement/trainer-member-map/TrainerMemberMap";
import BCAReport from "../trainer-member-engagement/bca-report/BCAReport";
import AvailableTrainers from "./live-trials/AvailableTrainers";
import CommonTable from "../common-components/common-tables/CommonTable";
import {
  CalendarIcon,
  CallIcon,
  CheckCircleIcon,
  ClockIconV3,
  PersonArmsUpIcon,
  PersonIcon,
  PersonStandingIcon,
  XCircleIcon,
  XIcon,
} from "../../images/icons/icons";
import {
  convertThenFormat,
  convertTo12HourFormat,
  formatDateTime,
} from "../common-data/Converts";
import ActionButtons from "./ActionButtons";

const LiveTbCols = ({
  from,
  userInfoData,
  allDatas,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  callFunction,
  isLoading,
}) => {
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const tbColumns = [
    {
      dataField: "user_name",
      text: "member info",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>{" "}
              <span className="tb-data">
                {row?.user_name || row?.name || "NA"}
              </span>{" "}
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CallIcon />
              </span>{" "}
              <span className="tb-data">
                {row?.user_mobile || row?.mobile || "NA"}
              </span>{" "}
            </div>

            {(row?.is_renewal === 1 || row?.is_renewal === 0) && (
              <div className="tb-flex">
                <span
                  className={`tb-badge ${
                    row?.is_renewal === 1
                      ? "tb-existing"
                      : row?.is_renewal === 0
                      ? "tb-fresh"
                      : ""
                  }`}
                >
                  {row?.is_renewal === 1
                    ? "Existing Member"
                    : row?.is_renewal === 0
                    ? "Fresh Member"
                    : "NA"}
                </span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 30;

        return (
          <span className={`tb-data ${isLong ? "tb-data-long" : ""}`}>
            {gymName}
          </span>
        );
      },
    },
    from !== "new_subscription" && {
      dataField: "trainer_id",
      text: "assigned trainer",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            {row?.default_trainer_id || row?.trainer_id ? (
              <>
                <div className="tb-flex">
                  <span className="tb-data tb-info-icon">
                    <PersonIcon />
                  </span>{" "}
                  <span className="tb-data">
                    {row?.default_trainer_name || row?.trainer_name || "NA"}
                  </span>{" "}
                </div>

                <div className="tb-flex">
                  <span className="tb-data tb-info-icon">
                    <CallIcon />
                  </span>{" "}
                  <span className="tb-data">
                    {row?.default_trainer_mobile || row?.trainer_mobile || "NA"}
                  </span>{" "}
                </div>
              </>
            ) : (
              <span
                className={`tb-badge not-assigned cursor-pointer`}
                onClick={() => {
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "trainer_member_map",
                    rowData: row,
                  }));
                }}
              >
                <XIcon color="#fff" /> not assigned
              </span>
            )}
          </div>
        );
      },
    },
    from !== "new_subscription" && {
      // from !== "renewals" &&
      dataField: "trainer_id",
      text: "assigned trainer shift",
      formatter: (_, row) => {
        const validShifts =
          row?.shift_details?.filter(
            (shift) =>
              shift && shift?.shift_name && shift?.start_time && shift?.end_time
          ) || [];

        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CalendarIcon />
              </span>
              <div className="tb-flex-col">
                {validShifts.length > 0 ? (
                  validShifts.map((shift, index) => (
                    <span key={index} className="tb-data">
                      {shift?.shift_name || ""} (
                      {convertTo12HourFormat(shift?.start_time)} -{" "}
                      {convertTo12HourFormat(shift?.end_time)})
                    </span>
                  ))
                ) : (
                  <span className="tb-data">-</span>
                )}
              </div>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <ClockIconV3 color="#2c3e50" />
              </span>
              <span className="tb-data">
                last checkin ({row?.last_checkin_date || "-"}{" "}
                {row?.last_checkin_time || ""})
              </span>
            </div>
          </div>
        );
      },
    },
    from === "new_subscription" && {
      dataField: "type",
      text: "plan type",
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            <span className="tb-data tb-info-icon">
              {row?.type === "regular" ? (
                <PersonStandingIcon color="#2c3e50" />
              ) : (
                <PersonArmsUpIcon color="#2c3e50" />
              )}
            </span>{" "}
            <span className="tb-data">
              {row?.type?.replace(/_/g, " ") || "-"}
            </span>
          </div>
        );
      },
    },
    (from === "renewals" || from === "new_subscription") && {
      dataField: "plan_id",
      text: "plan name",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span className="tb-data">{row?.plan_name || "NA"}</span>
            <span className="tb-data">
              @ ₹{convertThenFormat(row?.price || 0)}
            </span>
          </div>
        );
      },
    },
    (from === "renewals" || from === "new_subscription") && {
      dataField: "start_date",
      text: "plan duration",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CalendarIcon color="#2c3e50" />
              </span>{" "}
              <span className="tb-data">{row?.start_date || "-"}</span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CalendarIcon color="#2c3e50" />
              </span>{" "}
              <span className="tb-data">{row?.expire_date || "-"}</span>
            </div>
          </div>
        );
      },
    },
    from === "renewals" && {
      dataField: "days_remaining",
      text: "expiring",
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-badge tb-badge-stuck">
            {row?.days_remaining || 0} days
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text:
        from === "renewals"
          ? "reminder date"
          : from === "new_subscription"
          ? "Purchase date"
          : "Member Checkin Time",
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            <span className="tb-data tb-info-icon">
              <ClockIconV3 color="#2c3e50" />
            </span>{" "}
            <span className="tb-data">
              {from === "new_subscription"
                ? row?.purchase_date || "-"
                : formatDateTime(row?.date_added || "-")}
            </span>
          </div>
        );
      },
    },
    (from === "renewals" || from === "new_subscription") && {
      dataField: "user_id",
      text: "subs added by",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>{" "}
              <span className="tb-data">{row?.created_by_name || "NA"}</span>{" "}
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CallIcon />
              </span>{" "}
              <span className="tb-data">{row?.created_by_mobile || "NA"}</span>{" "}
            </div>
          </div>
        );
      },
    },
    from !== "new_subscription" && {
      dataField: "three_day_assigned",
      text: "trial",
      formatter: (_, row) => {
        const isTrialAssigned = row?.three_day_assigned ? true : false;

        return (
          <div className="tb-flex-col">
            {row?.three_day_assigned ? (
              <>
                <span
                  className="tb-data tb-icon tb-link"
                  onClick={() =>
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      modName: "trial_history",
                      rowData: row,
                    }))
                  }
                >
                  {row?.three_day_assigned ? (
                    <CheckCircleIcon />
                  ) : (
                    <XCircleIcon />
                  )}{" "}
                  {row?.three_day_done_count || 0}/3
                </span>
                {isTrialAssigned && row?.is_stuck !== "undefined" && (
                  <span
                    className={`tb-badge ${
                      row?.is_stuck === 1
                        ? "tb-badge-stuck"
                        : "tb-badge-success"
                    }`}
                    style={{
                      marginTop: "4px",
                    }}
                  >
                    {row?.is_stuck === 1 ? "stuck" : "on track"}
                  </span>
                )}
              </>
            ) : (
              <span
                className={`tb-badge not-assigned cursor-pointer`}
                onClick={() => {
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "trial_assign",
                    rowData: row,
                  }));
                }}
              >
                <XIcon color="#fff" /> not assigned
              </span>
            )}
          </div>
        );
      },
    },
    from !== "new_subscription" && {
      dataField: "handover_status",
      text: "Handover status",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.handover_status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    from !== "new_subscription" && {
      dataField: "bca_status",
      text: "BCA",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data tb-link"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "BCA_history",
                rowData: row,
              }))
            }
          >
            {row?.bca_status?.replace(/_/g, " ") || "view"}
          </span>
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: (_, row) => {
        return (
          <ActionButtons
            rowData={row}
            setModValues={setModValues}
            showPTTrial={from === "new_subscription" ? false : true}
            showMapTrainer={true}
            showView={true}
            showResolve={from === "new_subscription" ? false : true}
          />
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Edit Modal"
        ariaHideApp={false}
      >
        {modValues.modName === "resolve" ? (
          <ResolutionForm
            userInfoData={userInfoData}
            rowData={modValues.rowData}
            closeModal={onCloseModal}
            from={
              from === "pt_trial"
                ? "pt_trial"
                : from === "bca_pending"
                ? "bca"
                : from === "renewals"
                ? "renewal"
                : from === "member_checkins"
                ? "attendance"
                : ""
            }
            callFunction={callFunction}
          />
        ) : (
          <div
            className={`createNewCTOModalContainer ${
              modValues.modName === "trainer_member_map" ||
              modValues.modName === "view_details"
                ? "mod-width-50p"
                : modValues.modName === "trial_assign"
                ? "mod-width-50p mod-height-60vh"
                : "mod-width-95vw mod-height-95vh"
            }`}
          >
            {modValues.modName === "trial_assign" ||
            modValues.modName === "view_details" ? null : (
              <DetailModHeader
                info={modValues.rowData}
                onClose={onCloseModal}
                isOnlySubscription={true}
              />
            )}

            {modValues.modName === "trial_assign" ? (
              <TrialAssignForm
                rowData={modValues.rowData}
                closeModal={onCloseModal}
                userInfoData={userInfoData}
                callFunction={callFunction}
              />
            ) : modValues.modName === "trial_history" ? (
              <ThreedayTrialHistory
                rowData={modValues.rowData}
                userInfoData={userInfoData}
              />
            ) : modValues.modName === "trainer_member_map" ? (
              <TrainerMemberMap
                userInfoData={userInfoData}
                rowData={modValues.rowData}
                closeModal={onCloseModal}
                callFunction={callFunction}
              />
            ) : modValues.modName === "BCA_history" ? (
              <BCAReport
                userInfoData={userInfoData}
                rowData={modValues.rowData}
              />
            ) : modValues.modName === "view_details" ? (
              <AvailableTrainers
                userInfoData={userInfoData}
                rowData={modValues.rowData}
                closeModal={onCloseModal}
              />
            ) : null}
          </div>
        )}
      </Modal>

      <div className="common-table-container mt15">
        <CommonTable
          tableData={allDatas.allData}
          tablePagination={allDatas.pagination}
          tableColumns={tbColumns}
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          isLoading={isLoading}
        />
      </div>
    </>
  );
};

export default LiveTbCols;
